<template>
  <div class="business-page">
    <h1>Business Details</h1>

    <PatternSelectedBusiness
      :chip-text="chipText"
      :action-text="actionText"
      :business="businessData"
      :handle-click="handleClick"
    />
  </div>
</template>

<script>
  import PatternSelectedBusiness from '@/components/pattern/selectedBusiness/index.vue'

  export default {
    name: 'SelectedBusinessPage',
    components: {
      PatternSelectedBusiness
    },
    data() {
      return {
        chipText: 'Featured Business',
        actionText: 'Edit',
        businessData: {
          value: 'ABC Corp',
          modelValue: 'someModelValue',
          disabled: false,
          title: 'ABC Corporation',
          description: 'We provide innovative solutions.',
          state: 'Active',
          address: '123 Business Ave',
          zip: '12345',
          nonOperating: false,
          nonOperatingText: '',
          image: 'https://dummyjson.com/image/150'
        }
      }
    },
    methods: {
      handleClick() {
        alert('You clicked the edit button!');
      }
    }
  }
</script>

<style lang="scss" scoped>
.business-page {
  padding: $space-large;
}

h1 {
  font-size: $font-size-large;
  margin-bottom: $space-large;
}
</style>
